import { useEffect } from 'react';
import { createRootRoute } from '@tanstack/react-router';
import { Provider } from 'react-redux';

import Routes from '../Navigation/Routes';
import queryClient from '../queryClient';
import assembleStore from '../Redux';
import 'react-toastify/dist/ReactToastify.css';
import '../App.css';
import { Slide, ToastContainer } from 'react-toastify';
import { QueryClientProvider } from '@tanstack/react-query';
import RTStateChecker from '../Utils/RTStateChecker';

const keysToBlock = ['u', 's'];

// create our store
const { store } = assembleStore();

export const Route = createRootRoute({
  component: RootComponent,
});

export function RootComponent() {
  useEffect(() => document.addEventListener('keydown', handleKeyDown), []);
  useEffect(() => () => document.removeEventListener('keydown', handleKeyDown), []);

  // Some keystrokes are undesireable for all users.
  // Turn off (CTRL/CMD)-S (chrome=Save As)
  // Turn off (CTRL/CMD)-U (chrome&firefox=View Source)(Edge=Debugger mode)
  const handleKeyDown = (event: KeyboardEvent) => {
    const key = (event.key || '').toLowerCase();

    if ((event.ctrlKey || event.metaKey) && keysToBlock.includes(key)) {
      event.preventDefault();
    }
  };

  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <Routes />
        <ToastContainer
          position="top-right"
          autoClose={3500}
          newestOnTop={false}
          hideProgressBar={false}
          transition={Slide}
        />
        {import.meta.env.MODE === 'development' ? <RTStateChecker /> : null}
      </QueryClientProvider>
    </Provider>
  );
}
